// @flow
/** @jsx jsx */

import TextInput, {
  type TextInputProps,
} from '@zapier/common-components/src/components/TextInput';
import { jsx } from '@emotion/core';
import { Border, Colors } from '@zapier/theme';

const controlCss = {
  borderLeft: `${Border.size.default} solid ${Border.color.default}`,

  '*:last-child': {
    borderBottomRightRadius: 3,
    borderTopRightRadius: 3,
  },
};

const wrapperCss = hasError => ({
  alignItems: 'stretch',
  border: hasError
    ? `${Border.size.default} solid ${Colors.lava}`
    : `${Border.size.default} solid ${Border.color.default}`,
  borderRadius: Border.radius.default,
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'row',
  position: 'relative',

  '&:focus-within': {
    borderColor: Colors.heroine,
  },

  '*:first-of-type': {
    borderBottomRightRadius: 0,
    borderTopRightRadius: 0,
  },
});

type Props = {
  ...$Exact<TextInputProps>,
  /** Component on right */
  children: React.Node,
  inputHasError: boolean,
};

/**
 * Renders a `TextInput` with a combined component on the right side
 * anything given as children will be rendered as the right component
 *
 * any other props will be put on the `TextInput`
 */
const TextInputWithComponent = ({ children, ...props }: Props) => {
  return (
    <div css={wrapperCss(props.inputHasError)}>
      <TextInput isBorderHidden={true} {...props} />
      <div css={controlCss}>{children}</div>
    </div>
  );
};

TextInputWithComponent.defaultProps = {
  inputHasError: false,
};

export default TextInputWithComponent;
